export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

